import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=dce5a0e0&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce5a0e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dce5a0e0')) {
      api.createRecord('dce5a0e0', component.options)
    } else {
      api.reload('dce5a0e0', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=dce5a0e0&scoped=true&", function () {
      api.rerender('dce5a0e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26cl9JfAy4Ydw/JS/comp/Voucher-Unit.vue"
export default component.exports